import { StreamActions } from "@hotwired/turbo"
import ToastCustom from 'src/javascripts/components/alerts/ToastCustom';

export default function() {

	StreamActions.reload_datatables = function() {
		let tableId = this.getAttribute("table_id");
		let table = $('#' + tableId).DataTable();
		let scrollBody = table ? table.table().container().querySelector('.dataTables_scrollBody') : null;
		let scrollTop = scrollBody ? scrollBody.scrollTop : 0;
		table.ajax.reload(function() {
			if (scrollBody) { scrollBody.scrollTop = scrollTop; }
		}, false);
	}

	StreamActions.toast = function() {
	  let title = this.getAttribute("title");
	  let text = this.getAttribute("text");
	  let length = parseInt(this.getAttribute("length"));
	  ToastCustom(title, text, length);
	}

	StreamActions.show_modal = function() {
	  let modalId = this.getAttribute("modal_id");

	  // Remove existing modal
	  $('#' + modalId).remove();

		// Append content 
	  $('body').append(this.templateContent);

		// Enable client side validations in modal
		$('#' + modalId).on('shown.bs.modal', function() {
			$('#' + modalId).find('form').enableClientSideValidations();
		});

		// Re-init tooltips
		$('[data-toggle=tooltip]').tooltip();

		// Show the modal
	  $('#' + modalId).modal('show');
	}

	StreamActions.hide_modal = function() {
	  let modalId = this.getAttribute("modal_id");
		$('.modal-backdrop').remove();
	  $('#' + modalId).modal('hide').remove();
		$('[data-toggle=tooltip]').tooltip();
	}

}

